export default __webpack_public_path__ + "static/media/b29.dd484e6b.png";